<template>
  <div class="hadarsStatus" style="margin-top: 2%;margin-left:2%;color: #303133;">
    <el-row justify="left" type="flex">
      <el-col  :span="20" >
        <div class="hbasePic">
          <span class="pic" :class="hbaseStatus"></span>
          <span>HBase Status:</span>
          <span>{{hbaseWorkCount}}</span>
          <span>of</span>
          <span>{{hbasetotalCount}}</span>
          <span>working</span>
        </div>
        <div class="archiver" style="margin-top:2%;">
          <span class="pic" :class="archiverStatus"></span>
          <span>Archiever Status:</span>
          <span>{{archiverWorkCount}}</span>
          <span>of</span>
          <span>{{archivertotalCount}}</span>
          <span>working</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      name: "hadarsStatus",
      data(){
          return {
            hbaseWorkCount:1,
            hbasetotalCount:1,
            archiverWorkCount:1,
            archivertotalCount:1,
            hbaseStatus:'yellow',
            archiverStatus:'yellow',
          }
      },
      mounted(){
          this.query();
      },
      methods:{
        query:function () {
          this.$axios({ 
              method:'get',
                url:'/hdars/hdars/api/healthcheck'
              }).then((response) => {
            let data = response.data;
            this.hbaseWorkCount = data.hbase.workingCount;
            this.hbasetotalCount = data.hbase.totalCount;
            this.hbaseStatus = data.hbase.statusText;
            this.archiverWorkCount = data.archiver.workingCount;
            this.archivertotalCount = data.archiver.totalCount;
            this.archiverStatus = data.archiver.statusText;
          })
        },
      }
    }

</script>

<style>
.hadarsStatus .pic{
  display:inline-block;
  height: 42px;
  width: 42px;
  background-repeat: no-repeat;
  background-position: left center;
  border: none;
  vertical-align: middle;
}
.hadarsStatus .hbasePic .pic.green {
    background-image: url(../../../assets/hbase42-green.png);
}
.hadarsStatus .hbasePic .pic.red {
    background-image: url(../../../assets/hbase42-red.png);
}
.hadarsStatus .hbasePic .pic.yellow {
    background-image: url(../../../assets/hbase42-yellow.png);
}
.hadarsStatus .archiver .pic.green {
    background-image: url(../../../assets/archiver42-green.png);
}
.hadarsStatus .archiver .pic.red {
    background-image: url(../../../assets/archiver42-red.png);
}
.hadarsStatus .archiver .pic.yellow {
    background-image: url(../../../assets/archiver42-yellow.png);
}

</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/hadarsStatus.vue